import { anythingToString } from '@hawkins/helpers';
import { checkRawValuesDeepEqual, checkRawValuesReferentiallyEqual } from './dropdownEqualityChecks';
/**
 * Transforms the rawValue into DropdownOption[], ensuring any returned DropdownOption is generated in the following
 * priority order:
 *   1. A matching DropdownOption from the options array
 *   2. A consumer-provided onCreateOptionFromRawValue function
 *   3. The default onCreateOptionFromRawValue function
 */
export function normalizeRawValue(_a) {
    var checkRawValuesEqual = _a.checkRawValuesEqual, getOptionValue = _a.getOptionValue, onCreateOptionFromRawValue = _a.onCreateOptionFromRawValue, options = _a.options, rawValue = _a.rawValue;
    if (!rawValue || (Array.isArray(rawValue) && !rawValue.length))
        return undefined;
    // If checkRawValuesEqual is either of these two out-of-the-box rawValue equality functions, then we can take the
    // ultra performant route and do some convenient hashing of options by the rawValue.
    if (checkRawValuesEqual === checkRawValuesDeepEqual || checkRawValuesEqual === checkRawValuesReferentiallyEqual) {
        /** Options hashed by their value. Gives subsequent O(1) access to get the original option by providing the value */
        var optionsHashedByValue_1 = new Map();
        var getHashedOption_1 = function (rv) {
            if (checkRawValuesEqual === checkRawValuesDeepEqual) {
                return optionsHashedByValue_1.get(anythingToString(rv));
            }
            return optionsHashedByValue_1.get(rv);
        };
        var hashOption = function (option) {
            if (checkRawValuesEqual === checkRawValuesDeepEqual) {
                return optionsHashedByValue_1.set(anythingToString(getOptionValue(option)), option);
            }
            return optionsHashedByValue_1.set(getOptionValue(option), option);
        };
        options === null || options === void 0 ? void 0 : options.forEach(hashOption);
        if (Array.isArray(rawValue)) {
            return rawValue.map(function (rv) { return getHashedOption_1(rv) || onCreateOptionFromRawValue(rv); });
        }
        else if (rawValue) {
            return [getHashedOption_1(rawValue) || onCreateOptionFromRawValue(rawValue)];
        }
    }
    // In this case, we can't deterministically know that we the options can be hashed by a rawValue in a way that
    // can be accurately retrieved according to checkRawValuesEqual's expectations. Take a less performant route and
    // do manual comparisons to normalize each rawValue into an option whose value is "equal" by checkRawValuesEqual's
    // expectations.
    else {
        var getOptionWithEqualRawValue_1 = function (rv) {
            var optionWithEqualRawValue;
            if (options) {
                for (var i = 0; i < options.length; i++) {
                    var opt = options[i];
                    if (checkRawValuesEqual(getOptionValue(opt), rv)) {
                        optionWithEqualRawValue = opt;
                        break;
                    }
                }
            }
            return optionWithEqualRawValue;
        };
        if (Array.isArray(rawValue)) {
            return rawValue.map(function (rv) { return getOptionWithEqualRawValue_1(rv) || onCreateOptionFromRawValue(rv); });
        }
        else if (rawValue) {
            return [getOptionWithEqualRawValue_1(rawValue) || onCreateOptionFromRawValue(rawValue)];
        }
    }
    return undefined;
}
